import React from 'react';

// Components
import { Tooltip } from '@/views/components/tooltips';

interface MaskedCellProps {
  /** The text to be masked */
  text: string;
  /** Number of characters to show at the end */
  charactersToShow: number;
  /** Length of the blurred section (default: 8) */
  blurLength?: number;
  /** Whether to show tooltip with full text (default: false) */
  showTooltip?: boolean;
  /** Additional CSS classes */
  className?: string;
}

const MaskedData: React.FC<MaskedCellProps> = ({ text, charactersToShow, blurLength = 8, showTooltip = false, className = '' }) => {
  if (!text || charactersToShow < 0) {
    return (
      <span data-testid="regular-data" className={className}>
        {text}
      </span>
    );
  }

  // If the text is shorter than or equal to characters to show, display as-is
  if (text.length <= charactersToShow || blurLength <= 0) {
    return (
      <span data-testid="regular-data" className={className}>
        {text}
      </span>
    );
  }

  const blurSection = '•'.repeat(blurLength);
  const visiblePart = charactersToShow === 0 ? '' : text.slice(-charactersToShow);

  const maskedContent = (
    <span className={`masked-data ${className}`} data-private data-dd-privacy="mask" data-testid="masked-data">
      <span className="blur-section">{blurSection}</span>
      <span className="visible-section">{visiblePart}</span>
    </span>
  );

  if (showTooltip) {
    return (
      <Tooltip className="custom-tooltip-v2" message={text} data-private data-dd-privacy="mask">
        {maskedContent}
      </Tooltip>
    );
  }

  return maskedContent;
};

export default MaskedData;
